module.exports = __webpack_public_path__ + "static/media/crossIcon.617a966d.svg";